if (!customElements.get('nfm-flower-gallery')) {
  customElements.define('nfm-flower-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.images = JSON.parse(this.querySelector('[data-images]').textContent);
      this.scope = this.closest('[id^="MainProduct-"]');
      this.picker = this.scope.querySelector('variant-selects, variant-radios');
      this.mainImage = this.querySelector('[data-main-image]');
      this.caption = this.querySelector('[data-caption]');
      this.selection = this.querySelector('[data-selection]');
      this.thumbnails = this.querySelector('[data-thumbnails]');
      this.entries = [];
      const assigned = new Set();
      this.variants.forEach(variant => {
        if (!variant.featured_image) return;
        assigned.add(this.imageKey(variant.featured_image.src));
        this.addThumb(variant.featured_image.src, variant.title, variant);
      });
      this.images.forEach(image => {
        const src = typeof image === 'string' ? image : image.src;
        if (!assigned.has(this.imageKey(src))) this.addThumb(src, this.dataset.general);
      });
      this.onChange = () => {
        const options = this.picker ? Array.from(this.picker.querySelectorAll('select, fieldset'), el => el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value) : [];
        const variant = this.variants.find(v => v.options.every((value, i) => value === options[i]));
        if (variant) this.showVariant(variant);
      };
      this.picker?.addEventListener('change', this.onChange);
      this.showVariant(this.variants.find(v => String(v.id) === this.dataset.selected) || this.variants[0]);
      this.querySelector('[data-gallery-content]').hidden = false;
    }
    disconnectedCallback() { this.picker?.removeEventListener('change', this.onChange); this.ready = false; }
    imageKey(src) { return (src || '').split('?')[0].replace(/^https?:/, ''); }
    addThumb(src, label, variant) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nfm-gallery-thumb';
      button.setAttribute('aria-pressed', 'false');
      const img = document.createElement('img');
      img.src = src + (src.includes('?') ? '&' : '?') + 'width=180';
      img.alt = '';
      img.loading = 'lazy';
      const name = document.createElement('span');
      name.textContent = label;
      button.append(img, name);
      const entry = {button, src, label, variant};
      this.entries.push(entry);
      button.addEventListener('click', () => {
        if (!variant) { this.showPhoto(entry); return; }
        if (!this.picker) { this.showVariant(variant); return; }
        const groups = Array.from(this.picker.querySelectorAll('select, fieldset'));
        if (groups.length !== variant.options.length) return;
        let target;
        groups.forEach((group, i) => {
          if (group.tagName === 'SELECT') { group.value = variant.options[i]; target = group; }
          else { const radio = Array.from(group.querySelectorAll('input')).find(input => input.value === variant.options[i]); if (radio) { radio.checked = true; target = radio; } }
        });
        target?.dispatchEvent(new Event('change', {bubbles: true}));
      });
      this.thumbnails.append(button);
    }
    showPhoto(entry) {
      this.mainImage.hidden = false;
      this.mainImage.src = entry.src + (entry.src.includes('?') ? '&' : '?') + 'width=1000';
      this.mainImage.alt = this.dataset.title + ' — ' + entry.label;
      this.caption.textContent = this.mainImage.alt;
      this.entries.forEach(item => item.button.setAttribute('aria-pressed', String(item === entry)));
    }
    showVariant(variant) {
      if (!variant) return;
      this.selection.textContent = this.dataset.selectedLabel + ': ' + this.dataset.title + ' — ' + variant.title;
      const entry = this.entries.find(item => item.variant?.id === variant.id);
      if (entry) this.showPhoto(entry);
      else {
        this.mainImage.hidden = true;
        this.mainImage.removeAttribute('src');
        this.caption.textContent = variant.title + ' — ' + this.dataset.missing;
        this.entries.forEach(item => item.button.setAttribute('aria-pressed', 'false'));
      }
    }
  });
}
